import {
  fetchAuthSession,
  fetchUserAttributes,
  getCurrentUser,
} from '@aws-amplify/auth';

export type CurrentSession = {
  username: string;
  email: string;
  name: string;
  picture: string;
  roles: string[];
  id: string;
  accessToken: string;
  idToken: string;
};

export const getCurrentSession = async (): Promise<CurrentSession> => {
  const cognitoUser = await getCurrentUser();
  const cognitoUserAttributes = await fetchUserAttributes();
  const cognitoSession = await fetchAuthSession();

  return {
    username: cognitoUser.username,
    email: cognitoUserAttributes.email ?? '',
    name: cognitoUserAttributes.name ?? '',
    picture: cognitoUserAttributes.picture ?? '',
    roles:
      (cognitoSession.tokens?.accessToken?.payload[
        'cognito:groups'
      ] as string[]) ?? [],
    id: cognitoUserAttributes.sub ?? '',
    accessToken: cognitoSession.tokens?.accessToken.toString() ?? '',
    idToken: cognitoSession.tokens?.idToken?.toString() ?? '',
  };
};
